<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2022-11-06 20:17:07
 * @LastEditTime: 2023-02-18 11:13:44
 * @Description: 
-->
<template>
    <div class="btm_box">
        <div class="row_width flex_div">
            <div class="flex_div">
                <div class="h1">Company Rated：</div>
                <div class="max_w">{{PdftStore.fromData.orgInfo?.orgName}}</div>
            </div>
            <div class="flex_div">
                <div class="h1">Rating：</div>
                <div v-if="PdftStore.fromData.questionnaireInfo?.grade == 1">Bronze</div>
                <div v-if="PdftStore.fromData.questionnaireInfo?.grade == 2">Silver</div>
                <div v-if="PdftStore.fromData.questionnaireInfo?.grade == 3">Gold</div>
                <div v-if="PdftStore.fromData.questionnaireInfo?.grade == 4">Platinum</div>
                <div v-if="PdftStore.fromData.questionnaireInfo?.grade == 5">Diamond</div>
            </div>
            <div class="flex_div">
                <div class="h1">Company Sector：</div> 
                <div>{{PdftStore.fromData.orgInfo?.industry}}</div>
            </div>
            <div class="flex_div">
                <div class="h1">Time：</div> 
                <div>{{formatDateTimeYYmms(PdftStore.fromData.questionnaireInfo?.evaluationDate)}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'bottoms',
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.btm_box{
    position: absolute;
    bottom: 90px;
    width: 1252px;
    border-top: 2px solid #013C89;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top: 6px;
    .row_width{
        width: 100%;
    }
    .h1{
        font-size: 14px;
        font-weight: 600;
    }
    .flex_div{
        display: flex;
        justify-content: space-between;
    }
    .btm_banner{
        font-size: 14px;
        font-weight: 400;
        max-width: 800px;
        color: #666666;
        line-height: 20px;
        text-align: right;
    }
    .max_w{
        max-width: 400px;
        word-wrap: break-word;
    }
    .logo_txt{
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        text-align: right;
        display: flex;
        align-items: center;
        .img_min{
            width: 20px;
            height: 20px;
            margin: 0 5px;
        }
    }
}
</style>